import React from 'react'
import styled from '@emotion/styled'

export const Footer: React.FC = () => {
	return (
		<Container>
			<Content>
				<Left>
					&copy; copyright2022.unitmi Corp.All Right Reserved
					<br />
					(주)유닛미 | 서울특별시 강남구 테헤란로79길 6, 제이에스타워 5층 브이796(삼성동)
					<br />
					사업자등록번호 : 860-81-02511 | 통신판매업신고 : 2023-서울강남-03439
					<br />
					대표 : 김성윤 | 개인정보책임자 : 김성윤
					<br />
					고객센터 : 070-8997-9661
				</Left>
				<Right>
					<a
						href="https://picturesque-avatar-ac9.notion.site/689fb573de9646cba3deebb33dc8dfb7?pvs=4"
						target="_blank"
						rel="noreferrer"
					>
						이용약관
					</a>
					&nbsp;|&nbsp;
					<a
						href="https://picturesque-avatar-ac9.notion.site/0d67317452ca442295f71cd8b7e1b9f6?pvs=4"
						target="_blank"
						rel="noreferrer"
					>
						개인정보취급방침
					</a>
				</Right>
			</Content>
		</Container>
	)
}

const Container = styled.footer`
	background: #eef0f5;
`

const Content = styled.div`
	margin: 0 auto;
	padding: 40px 80px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`

const Left = styled.div`
	font-size: 12px;
	color: #565656;
	line-height: 1.5;
`

const Right = styled.div`
	& a {
		color: #565656;
		font-size: 12px;
		line-height: 1.5;
	}
`
